var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlayLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1625 13.375L1.39746 25.6807C1.52957 26.1482 1.76698 26.5793 2.09155 26.9411C2.41612 27.3029 2.81926 27.5858 3.27014 27.7682C3.72103 27.9506 4.20772 28.0277 4.69302 27.9936C5.17831 27.9594 5.64937 27.815 6.07017 27.5712L19.308 20.0442L13.1625 13.375Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.058 11.2831L19.3332 8.00977L12.8896 13.655L19.3595 20.0267L25.0404 16.7883C25.5437 16.5252 25.9653 16.1297 26.2594 15.6444C26.5536 15.1592 26.7091 14.6029 26.7091 14.0357C26.7091 13.4686 26.5536 12.9122 26.2594 12.427C25.9653 11.9418 25.5437 11.5462 25.0404 11.2831H25.058Z",
    fill: "#FBBC04"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.39723 2.33008C1.32611 2.59255 1.29073 2.86339 1.29203 3.13529V24.876C1.29274 25.1478 1.32809 25.4183 1.39723 25.6812L13.5655 13.6906L1.39723 2.33008Z",
    fill: "#4285F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2502 14.0056L19.3343 8.01031L6.114 0.448326C5.61665 0.157523 5.05098 0.00350565 4.47461 0.00195938C3.77851 0.000582205 3.10105 0.22648 2.5455 0.645218C1.98995 1.06396 1.58678 1.65256 1.39746 2.32132L13.2502 14.0056Z",
    fill: "#34A853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayLogo);
export default __webpack_public_path__ + "static/media/google-play-logo.3fcb414efa003261e37bd56c1a909eec.svg";
export { ForwardRef as ReactComponent };